import { useMutation } from '@tanstack/react-query';
import * as Yup from 'yup';
import { updateSiteRecce } from '@api/services/site-recce.service';
import { ISiteReccee } from '@api/models/site-recce.model';
import { AssetTypeEnum, SiteReccePriorityEnum, SiteRecceStatusEnum, SiteRecceTypeEnum } from '@api/enum';

export type TSiteRecceUpdateFormValues = {
    // remarks: string;
    preferredDate: string;
    priority: SiteReccePriorityEnum;
    type: SiteRecceTypeEnum | null;
    assetType: AssetTypeEnum | null;
    poRecieved: boolean;
    quantity?: number;
};

const useSiteRecceUpdateForm = (
    clientInstallationId: string,
    projectInstallationId: string,
    initialData: ISiteReccee
) => {
    const schema = Yup.object({
        remarks: Yup.string().required('Remarks are required'),
        preferredDate: Yup.string().nullable(),
        priority: Yup.mixed<SiteReccePriorityEnum>()
            .oneOf(Object.values(SiteReccePriorityEnum))
            .required('Priority is required'),
        type: Yup.mixed<SiteRecceTypeEnum>()
            .oneOf([...Object.values(SiteRecceTypeEnum), null])
            .nullable(),
        assetType: Yup.mixed<AssetTypeEnum>()
            .oneOf([...Object.values(AssetTypeEnum), null])
            .nullable(),
        poRecieved: Yup.boolean().required('PO status is required'),
    });

    const initialValues: TSiteRecceUpdateFormValues = {
        // remarks: initialData?.remarks || '',
        preferredDate: initialData?.preferredDate || '',
        priority: initialData?.priority || SiteReccePriorityEnum.HIGH,
        type: initialData?.type ?? null,
        assetType: initialData?.assetType ?? null,
        poRecieved: initialData?.poRecieved ?? false,
        quantity: initialData?.quantity ?? 0,
    };

    const mutation = useMutation((payload: TSiteRecceUpdateFormValues) =>
        updateSiteRecce(clientInstallationId, projectInstallationId, initialData._id, payload)
    );

    const submit = async (values: TSiteRecceUpdateFormValues) => {
        const data = await mutation.mutateAsync(values);
        return data;
    };

    return {
        initialValues,
        schema,
        isSubmitting: mutation.isLoading,
        submit,
    };
};

export default useSiteRecceUpdateForm;
